import { List, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'

const Introduction = () => {
    return (
        <Box className='flex flex-col mb-4'>
            <Box className="flex flex-col border-b border-gray-200">
                <Typography variant="h5" marginBottom={6} fontWeight={600} fontSize={20}>Novus OmniFleet Developer APIs</Typography>
                <Typography variant="h6" marginBottom={1} fontWeight={600} fontSize={16}>API Integration Documentation</Typography>
                <Typography variant='body2' marginBottom={2} fontSize={14} fontWeight={400}>
                    Welcome to the comprehensive suite of Novus OmniFleet REST APIs and webhooks. Our developer-friendly APIs are engineered to seamlessly integrate with your existing systems, providing powerful access to telematics data, safety monitoring, driver management, and asset tracking capabilities. Leverage these robust tools to build innovative solutions that enhance fleet operations and drive business efficiency.
                </Typography>
            </Box>
            <Box className="flex flex-col border-b border-gray-200 mt-4">
                <Typography variant="h6" marginBottom={2} fontWeight={600} fontSize={16}>API Categories</Typography>
                <Typography variant='body2' marginBottom={1} fontSize={14} fontWeight={600}>
                    Resource Management APIs
                </Typography>
                <List sx={{ listStyleType: 'disc', paddingLeft: 4, marginBottom: 2 }}>
                    <li className='text-sm'>Full CRUD (Create, Read, Update, Delete) operations for managing fleet resources including vehicles, drivers, and organizational data.</li>
                </List>
                <Typography variant='body2' marginBottom={1} fontSize={14} fontWeight={600}>
                    Telematics & Data APIs
                </Typography>
                <List sx={{ listStyleType: 'disc', paddingLeft: 4, marginBottom: 2 }}>
                    <li className='text-sm'>Access comprehensive vehicle telematics including real-time sensor data, GPS tracking, video footage, and live streaming capabilities.</li>
                </List>
                <Typography variant='body2' marginBottom={1} fontSize={14} fontWeight={600}>
                    Real-time Webhooks
                </Typography>
                <List sx={{ listStyleType: 'disc', paddingLeft: 4, marginBottom: 2 }}>
                    <li className='text-sm'>Event-driven notifications for instant alerts and location updates to keep your systems synchronized.</li>
                    <li className='text-sm'>Alert Webhooks: Instant notifications for critical events including speeding violations, geofence breaches, harsh driving behavior, and maintenance alerts.</li>
                    <li className='text-sm'>Location Webhooks: Real-time GPS position updates for continuous fleet tracking and route optimization.</li>
                </List>
            </Box>
            <Box className="flex flex-col border-b border-gray-200 mt-4">
                <Typography variant="h6" marginBottom={2} fontWeight={600} fontSize={16}>API Endpoints</Typography>
                <Typography variant='body2' marginBottom={1} fontSize={14} fontWeight={600}>
                    Production Base URL
                </Typography>            
                <List sx={{ listStyleType: 'disc', paddingLeft: 4, marginBottom: 2 }}>
                    <li className='text-sm'><strong>https://backend.novusomnifleet.com</strong> - Primary endpoint for all global customers and production environments</li>
                </List>
                <Typography variant='body2' marginBottom={1} fontSize={14} fontWeight={400} color="text.secondary">
                    All API requests should be made using HTTPS protocol. Ensure your application is configured to use the correct base URL for your region and environment.
                </Typography>
            </Box>
        </Box>
    )
}

export default Introduction